import React from "react";
import { useAppSettingsService } from "src/services/appSettingsService/appSettingsService";
import { useSelector } from "src/store";

import { selectGroups } from "@dashboard/groups/store/selectors";
import Grid from "@mui/material/Grid";

import { EventChartCard } from "../EventChartCard/EventChartCard";

import EnrollmentProgressCard from "./EnrollmentProgressCard/EnrollmentProgressCard";
import { ManagedAppsCard } from "./ManagedAppsCard/ManagedAppsCard";
import OnlineStatusCard from "./OnlineStatusCard/OnlineStatusCard";
import { OperatingSystemsCard } from "./OperatingSystemsCard/OperatingSystemsCard";
import { ProductsCard } from "./ProductsCard/ProductsCard";
import SubscriptionStatusCard from "./SubscriptionStatusCard/SubscriptionStatusCard";
import { WarningCard } from "./WarningCard";

export const StatisticSection = (props: { filter: number[] }) => {
    const { effectiveWorkspaceSettings } = useAppSettingsService();
    const activityChartEnabled = effectiveWorkspaceSettings.isOverviewPageShowingActivityChart;
    const groups = useSelector(selectGroups);
    const groupsIds = React.useMemo(() => groups.map((group) => group.id), [groups]);
    const groupsForStatistics = React.useMemo(() => (props.filter.length ? props.filter : groupsIds), [props.filter, groupsIds]);

    return (
        <Grid container spacing={1}>
            <Grid size={{ xs: 12, md: 3 }}>
                <SubscriptionStatusCard />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
                <EnrollmentProgressCard />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
                <OnlineStatusCard groupIds={groupsForStatistics} />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
                <WarningCard groupIds={groupsForStatistics} />
            </Grid>
            {activityChartEnabled && (
                <Grid size={{ xs: 12, md: 12 }}>
                    <EventChartCard groupIds={groupsForStatistics} />
                </Grid>
            )}
            <Grid size={{ xs: 12, md: 4 }}>
                <ManagedAppsCard groupIds={groupsForStatistics} />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <ProductsCard groupIds={groupsForStatistics} />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <OperatingSystemsCard groupIds={groupsForStatistics} />
            </Grid>
        </Grid>
    );
};
